import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

// Fonts are bundled, not fetched. The handhelds run offline in the aisle, so a
// Google Fonts request would simply fail and fall back to a system face.
//
// Subsets are pinned rather than importing the whole family: the unscoped entry points
// pull cyrillic, vietnamese and latin-ext too, which the service worker would then
// precache for nothing. Persian text and Persian digits both live in the arabic subset;
// the mono face only ever renders Latin codes and ASCII digits.
import '@fontsource/vazirmatn/arabic-400.css'
import '@fontsource/vazirmatn/arabic-500.css'
import '@fontsource/vazirmatn/arabic-600.css'
import '@fontsource/vazirmatn/arabic-700.css'
import '@fontsource/vazirmatn/arabic-800.css'
import '@fontsource/vazirmatn/latin-400.css'
import '@fontsource/vazirmatn/latin-700.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import '@fontsource/ibm-plex-mono/latin-600.css'

import './styles/global.css'
import { AuthProvider } from './app/AuthProvider'
import { ScanModeProvider } from './app/ScanModeProvider'
import { queryClient } from './app/queryClient'
import { router } from './app/router'

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('#root is missing from index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ScanModeProvider>
          <RouterProvider router={router} />
        </ScanModeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
